import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import VueScrollTo from 'vue-scrollto'
import './style/base.scss'
import './icons/index' //svgicon公共组件化
import 'element-ui/lib/theme-chalk/display.css';
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: 'cI2H63y27H04rdPytzZ1djBOIt62Yw2a'
})

Vue.use(ElementUI)
Vue.use(VueScrollTo)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
